<!-- 客户公海 -->
<template>
  <div class="content">
    <div class="header">
      <div class="text">客户公海</div>
    </div>
    <!-- 搜索部分 -->
    <div class="search-box">
      <veui-form
        :data="formData"
        @submit="handleSubmit"
      >
        <veui-field
          label="客户名"
          class="name m"
        >
          <veui-input
            v-model="formData.name"
            placeholder="请输入姓名"
          />
        </veui-field>
        <veui-field
          label="执业资格证号"
          class="certificate-no l"
        >
          <veui-input
            v-model="formData.license"
            :trim="true"
            placeholder="请输入资格证号"
          />
        </veui-field>
        <veui-field label="手机号" class="l">
          <veui-input
            v-model="formData.phone"
            :trim="true"
            placeholder="请输入手机号"
          />
        </veui-field>
        <veui-field
          label="城市"
          class="city m"
        >
          <citySelect
            class="city-option"
            :city="formData.city"
            @cityChange="cityChange"
            type="2"
          />
        </veui-field>
        <veui-field label="转化意愿" class="wish l">
          <veui-select
            v-model="formData.intentionType"
            class="option"
            placeholder="请选择"
            :options="wishOptions"
            clearable
          />
        </veui-field>
        <veui-field label="免费体验会员" class="free-vip l">
          <veui-select
            v-model="formData.freeVip"
            class="option"
            placeholder="请选择"
            :options="freeVipOptions"
            clearable
          />
        </veui-field>
        <veui-field label="线索来源" class="clue-from m">
          <veui-select
            v-model="formData.enterType"
            class="option"
            placeholder="请选择"
            :options="clueFromOptions"
            clearable
          />
        </veui-field>
        <veui-field label="入驻时间" class="join-date l">
          <veui-date-picker
            range
            clearable
            class="join-date-picker"
            overlay-class="join-date-picker-popup"
            v-model="formData.joinDate"
          />
        </veui-field>
        <veui-field label="会员失效时间" class="l">
          <veui-date-picker
            range
            clearable
            class="end-date-picker"
            overlay-class="end-date-picker-popup"
            v-model="formData.vipInvalidDate"
          />
        </veui-field>
        <veui-field
          v-if="isCrm"
          label="客户类型"
          class="custome-type m"
        >
            <veui-select
                v-model="formData.type_from"
                class="option"
                placeholder="请选择"
                :options="customerTypeList"
                clearable
            />
        </veui-field>
        <template #actions>
          <veui-button ui="strong" @click="resetForm">重置</veui-button>
          <veui-button ui="primary" type="submit">查询</veui-button>
        </template>
      </veui-form>
    </div>
    <veui-table
      :data="tableData"
      :scroll="{x: 1104}"
      role="columnheader"
      :loading="isLoading"
    >
      <veui-table-column
        field="name"
        title="客户名"
        width="100"
      >
        <template #default="{ name }">
          {{ name || '-' }}
        </template>
      </veui-table-column>
      <veui-table-column
          v-if="isCrm"
          field="from_type"
          title="客户类型"
          width="120"
      >
          <template #default="{ from_type }">
            {{ from_type || '-' }}
          </template>
      </veui-table-column>
      <veui-table-column
          v-if="isCrm"
          field="channel"
          title="渠道标识"
          width="120"
      >
          <template #default="{ channel }">
            {{ channel || '-' }}
          </template>
      </veui-table-column>
      <veui-table-column
        field="enter_type"
        title="线索来源"
        width="120"
      >
        <template #default="{ enter_type }">
          {{ +enter_type === 2 ? '自主入驻' : '代理商引入'}}
        </template>
      </veui-table-column>
      <veui-table-column
        field="encodeLicense"
        title="执业资格证号"
        width="200"
      >
        <template #default="{ encodeLicense }">
          {{ encodeLicense || '-'}}
        </template>
      </veui-table-column>
      <veui-table-column
          field="year"
          title="执业年限"
          width="120"
      >
          <template #default="{ year }">
            {{ year ? `执业${year}年` : '-' }}
          </template>
      </veui-table-column>
      <veui-table-column
        field="city"
        title="城市"
        width="100"
      >
        <template #default="{ city_name }">
          {{ city_name | cityNameFilter }}
        </template>
      </veui-table-column>
      <veui-table-column
        field="encodePhone"
        title="电话"
        width="140"
      >
        <template #default="{ encodePhone }">
          {{ encodePhone || '-' }}
        </template>
      </veui-table-column>
      <veui-table-column
        field="intention_count"
        width="120"
        desc="自主点击授权过手机号的客户转化意愿为强，反之则为普通"
      >
        <template #head>
          <div class="title-head">
            转化意愿
            <img class="icon" src="../../assets/img/law/question.svg" />
          </div>
        </template>
        <template #default="{ intention_count }">
          {{ +intention_count > 0 ? '强' : '正常'}}
        </template>
      </veui-table-column>
      <veui-table-column
        field="free_vip"
        width="140"
        desc="客户是否领取过免费10天体验会员"
      >
        <template #head>
          <div class="title-head">
            免费体验会员
            <img class="icon" src="../../assets/img/law/question.svg" />
          </div>
        </template>
        <template #default="{ free_vip }">
          <div class="label" :class="+free_vip === 2 ? 'blue' : 'green'">
            {{ +free_vip === 2 ? '是' : '否' }}
          </div>
        </template>
      </veui-table-column>
      <veui-table-column
        field="lawyer_enter_time"
        width="140"
        desc="客户注册进入律临的时间"
      >
        <template #head>
          <div class="title-head">
            入驻时间
            <img class="icon" src="../../assets/img/law/question.svg" />
          </div>
        </template>
        <template #default="{ lawyer_enter_time }">
          {{ lawyer_enter_time | dateFilter }}
        </template>
      </veui-table-column>
      <veui-table-column
        field="vip_end_time"
        width="160"
        desc="会员开始失效的时间"
      >
        <template #head>
          <div class="title-head">
            会员码失效时间
            <img class="icon" src="../../assets/img/law/question.svg" />
          </div>
        </template>
        <template #default="{ vip_end_time }">
          {{ vip_end_time | dateFilter }}
        </template>
      </veui-table-column>
      <veui-table-column
        field="operation"
        title="操作"
        width="130"
        fixed="right"
      >
        <template #default="{ index }">
          <div>
            <veui-button
              ui="text"
              @click="reveive(index)"
            >
              领取
            </veui-button>
            <veui-button
              ui="text"
              @click="openDetail(index)"
            >
              详情
            </veui-button>
          </div>
        </template>
      </veui-table-column>
    </veui-table>
    <!-- 分页 -->
    <veui-pagination
      v-if="tableData && tableData.length"
      :page="pn"
      :page-size="rn"
      :total="count"
      class="pagination"
      @redirect="pageChange"
    />
    <confirmDialog
      content="领取后用户将自动进入您的潜客列表成为您客保中的潜客，您的客保名额将随之消耗。"
      title="您确定要领取这条线索吗？"
      v-if="isShowConfirmDialog"
      @cancel="cancelReceive"
      @confirm="toClaim"
    />
    <!-- 详情 -->
    <customerDetail
      v-if="openDetailDrawer"
      :open="openDetailDrawer"
      :data="detailData"
      @closeDrawer="openDetailDrawer = false;"
    />
    <confirmDialog
      title="添加失败"
      :content="errorMsg"
      confirm-btn="我知道了"
      @confirm="closeFailureDialog"
      @cancel="closeFailureDialog"
      :is-show-cancel-btn="false"
      v-if="isShowFailureDialog"
    />
  </div>
</template>

<script>
import {
  Select,
  Input,
  Form,
  Field,
  Button,
  Table,
  Column,
  Pagination,
  DatePicker
} from 'veui';
import citySelect from '@/components/citySelect.vue';
import {wishOptions, freeVipOptions, clueFromOptions, customerTypeList} from './util/config';
import {dateFilter, cityNameFilter} from '@/utils/filter';
import confirmDialog from '@/components/confirm-dialog.vue';
import customerDetail from './components/customer-detail.vue';
import {mapState} from 'vuex';
import dayjs from 'dayjs';

export default {
  name: 'customerSea',
  components: {
    'veui-select': Select,
    'veui-input': Input,
    'veui-form': Form,
    'veui-field': Field,
    'veui-button': Button,
    'veui-table': Table,
    'veui-table-column': Column,
    'veui-pagination': Pagination,
    citySelect,
    'veui-date-picker': DatePicker,
    confirmDialog,
    customerDetail
  },
  filters: {
    cityNameFilter,
    dateFilter
  },
  data() {
    return {
      formData: {
        name: '',
        // 资格证号
        license: '',
        phone: '',
        city: [],
        // 线索来源
        enterType: null,
        // 是否免费体验会员
        freeVip: null,
        // 意愿
        intentionType: null,
        joinDate: null,
        vipInvalidDate: null,
        type_from: null
      },
      wishOptions,
      freeVipOptions,
      clueFromOptions,
      customerTypeList,
      tableData: [],
      rn: 10,
      pn: 1,
      // 是否展示确认弹框
      isShowConfirmDialog: false,
      // 详情数据
      detailData: {},
      isLoading: false,
      // 是否打开详情抽屉
      openDetailDrawer: false,
      // 机构id
      fid: '',
      // 总数
      count: 0,
      errorMsg: '',
      isShowFailureDialog: false
    };
  },
  computed: {
    ...mapState({
      userInfoNew: state => state.lawStore.userInfoNew,
      law_firm_info: state => state.lawStore.userInfoNew.law_firm_info || state.lawStore.userInfoNew.law_firm_subaccount || {}
    }),
    isCrm() {
        return this.law_firm_info && this.law_firm_info.crm_from;
    }
  },
  watch: {
    userInfoNew: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        let firm_info = newVal?.law_firm_info || newVal?.law_firm_subaccount || {};
        this.fid = firm_info?.id || '';
        this.$wywLog.addKey({
          fid: this.fid || ''
        });
      }
    }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**
     * 提交查询
     * @param {Object} data 表单信息
     */

    handleSubmit(data) {
      this.pn = 1;
      this.getTableData();
    },

    /**
     * 城市筛选过改变时
     * @param {Object} data 选中城市数据
     */

    cityChange(data = {}) {
      let {selectedData} = data;
      this.formData.city = selectedData;
    },

    /**
     * 重置
     */

    resetForm() {
      this.formData = {
        name: '',
        license: '',
        phone: '',
        city: [],
        enterType: null,
        freeVip: null,
        intentionType: null,
        joinDate: null,
        vipInvalidDate: null,
        type_from: null
      };
    },

    /**
     * 点击详情时触发
     * @param {Number} index 行下标
     */

    openDetail(index) {
      this.$wywLog.send({
        serverId: 16877,
        action: 'click',
        area: 'lvlin-crm-khgh-xq'
      });
      this.openDetailDrawer = true;
      this.detailData = this.tableData[index] || {};
    },

    /**
     * 点击领取按钮
     * @param {Number} index 行下标
     */

    reveive(index) {
      this.$wywLog.send({
        serverId: 16877,
        action: 'click',
        area: 'lvlin-crm-khgh-get',
        qc_core_no: this.detailData?.qc_core_no || ''
      });
      this.isShowConfirmDialog = true;
      this.detailData = this.tableData[index] || {};
    },

    /**
     * 确认领取
     * @param {Number} index 行下标
     */

    toClaim() {
      if (this.isSubmit) {
        return;
      }
      this.$wywLog.send({
        serverId: 16877,
        action: 'click',
        area: 'lvlin-crm-get-yesbtn',
        qc_core_no: this.detailData?.qc_core_no || ''
      });
      this.isSubmit = true;
      this.$http.post('/bp/crm/addcilawyer', {
        fid: this.fid,
        qc_core_no: this.detailData?.qc_core_no || ''
      }).then(res => {
        this.$wywLog.send({
          serverId: 16877,
          action: 'click',
          area: !res || +res.code !== 0 ? 'crm-get-fail' : 'crm-get-success',
          qc_core_no: this.detailData?.qc_core_no || ''
        });
        if (res && +res?.code === 3009) {
          this.errorMsg = res?.msg;
          this.showFailureDialog();
          return;
        }
        if (!res || +res.code !== 0) {
          this.$Message.error(res?.msg || '认领失败，请稍后再试');
          return;
        }
        this.$Message.success('认领成功');
        this.handleSubmit();
      }).catch(() => {
        this.$wywLog.send({
          serverId: 16877,
          action: 'click',
          area: 'crm-get-fail',
          qc_core_no: this.detailData?.qc_core_no || ''
        });
      }).finally(() => {
        this.isShowConfirmDialog = false;
        this.isSubmit = false;
      });
    },

    /**
     * 点击取消领取按钮
     * @param {Number} index 行下标
     */

    cancelReceive() {
      this.isShowConfirmDialog = false;
      this.$wywLog.send({
        serverId: 16877,
        action: 'click',
        area: 'lvlin-crm-get-nobtn',
        qc_core_no: this.detailData?.qc_core_no || ''
      });
    },

    /**
     * 获取表格数据
     */

    getTableData() {
      this.isLoading = true;
      let postParams = {
          ...this.formatFormData(),
          pn: this.pn,
          rn: this.rn
      };
      this.$http.post('/bp/crm/gethighseaslist', {
          ...postParams
      }).then(res => {
        if (!res || +res.code !== 0 || !res.data) {
          this.tableData = [];
          return;
        }
        this.tableData = res?.data?.list || [];
        this.count = res?.data?.count || 0;
      }).finally(() => {
        this.isLoading = false;
      });
    },

    /**
     * 翻页时更新数据
     *
     * @param {number} pn 第几页
     */

    pageChange(pn) {
      this.pn = pn;
      this.getTableData();
    },

    /**
     * 处理搜索参数
     */

    formatFormData() {
      let {
          city,
          license,
          phone,
          name,
          enterType,
          freeVip,
          intentionType,
          joinDate,
          vipInvalidDate,
          type_from = ''
      } = this.formData || {};
      let [vipInvalidStartTime, vipInvalidEndTime] = vipInvalidDate || [];
      let [clueStartTime, clueEndTime] = joinDate || [];
      let params = {
        license,
        phone,
        name,
        type_from,
        enterType: enterType || '',
        freeVip: freeVip || '',
        intentionType: intentionType || '',
        enterTimeRange: clueStartTime && clueEndTime
          ? dayjs(clueStartTime).unix() + ',' + dayjs(clueEndTime).hour(23).minute(59).second(59).unix() : '',
        vipEndRange: vipInvalidStartTime && vipInvalidEndTime
          ? dayjs(vipInvalidStartTime).unix() + ','
            + dayjs(vipInvalidEndTime).hour(23).minute(59).second(59).unix() : '',
        city: city?.[1]?.value || ''
      };
      return params;
    },
    /**
     * 打开添加失败弹窗
     */
    showFailureDialog() {
      this.isShowFailureDialog = true;
    },
    /**
     * 关闭添加失败弹窗
     */
    closeFailureDialog() {
      this.isShowFailureDialog = false;
    }
  }
};
</script>

<style lang='less' scoped>
@import '../../assets/css/law-table.less';
@inputWidth:200px;
@inputWidthLarge:252px;
.content {
  background: #fff;
  box-shadow: 0 6px 14px 0 rgba(227,233,237,0.35);
  border-radius: 8px;
  padding: 32px 30px 20px;

  .header {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    position: relative;

    .text {
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #000;
      line-height: 18px;
    }
  }
  .search-box {
    .veui-form {
      display: flex;
      flex-wrap: wrap;
      position: relative;

      .veui-button {
        height: 40px;
        width: 80px;
        font-size: 16px;
        border-radius: 5px;
      }
    }

    .certificate-no,
    .name,
    .type,
    .city,
    .wish,
    .clue-from,
    .join-date,
    .custome-type {
      margin-right: 30px;
    }

    /deep/.veui-field.l {
      .veui-input {
        width: @inputWidthLarge;
      }
      .option {
        width: @inputWidthLarge;
      }
    }
    /deep/.veui-field {
      margin-bottom: 18px;
      height: 40px;

      .veui-field-label {
        margin-right: 0;
        width: 30px;
        line-height: 40px;
        height: 40px;
        justify-content: flex-start;
      }

      &.l .veui-field-label {
        width: 98px;
      }

      &.m .veui-field-label {
        width: 80px;
      }
    }

    /deep/.veui-form-actions {
      margin-top: 0;
      padding-left: 0;

      .veui-button {
        margin-left: 0;

        &:last-child {
          margin-left: 10px;
        }
      }
    }

    .veui-input {
      width: @inputWidth;
      height: 40px;
      border: 1px solid #E9ECF3;
      border-radius: 8px;

      &.veui-focus,
      &:hover {
        border: 1px solid #3855D5;
        box-shadow: none;
      }
    }

    .veui-select.veui-select-expanded {
      border: 1px solid #3855D5;
    }

    /deep/.option {
      width: @inputWidth;
      height: 40px;
      display: inline-flex;
      // margin-left: 20px;
      border: 1px solid #E9ECF3;
      border-radius: 8px;

      .veui-input {
          border: none;
      }

      &:focus,
      &:hover,
      &.veui-select-expanded {
        border: 1px solid #3855D5;
      }
    }

    .city-option {
      /deep/.ivu-input {
        width: @inputWidth;
      }
    }
  }

  .veui-table {
    margin-top: 24px;

    .title-head {
      display: flex;
      cursor: pointer;

      .icon {
        height: 14px;
        width: 14px;
        margin-left: 2px;
      }
    }

    .veui-table-cell-content {
      .veui-button {
          color: #05f;
      }
    }

    .veui-table-cell-content .label {
      &.green {
        color: #17B42F;
      }

      &.blue {
        color: #3855D5;
      }
    }
  }
}
.join-date-picker,
.end-date-picker {
  width: 252px;

  /deep/.veui-date-picker-trigger {
    height: 40px;
    border-radius: 8px;
    border: 1px solid #e9ecf3;

    &::hover {
      border: 4px solid #3855d5;
    }
  }
}
/deep/.veui-date-picker-trigger:hover {
  border: 1px solid #3855d5 !important;
}
.pagination {
  float: right;
  padding: 30px 0;
}
</style>
<style lang="less">
  .veui-overlay-box.join-date-picker-popup,
  .veui-overlay-box.end-date-picker-popup {
    top: 40px !important;
  }
</style>
